/* Wholesale page — progressive enhancement only.
   Page is fully functional without JS (anchors still jump natively).
   Adds smooth scroll with an offset for the sticky jump-nav. */
(function () {
  'use strict';
  if (!('scrollBehavior' in document.documentElement.style)) return;

  var nav = document.querySelector('.ws-nav');
  function offset() { return nav ? nav.offsetHeight + 8 : 0; }

  document.querySelectorAll('.ws-page a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset();
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  });
})();
